import React from "react";
import OrderStatusSpan from "./OrderStatusSpan";
import DateTimeSpan from "./DateTimeSpan";

type OrderStatusCardProps = {
    date: string;
    status: string;
}

const OrderStatusCard: React.FC<OrderStatusCardProps> = ({date, status}) => {
    return (
        <>
            <div className="bg-white rounded-lg shadow-sm border border-gray-200">
                <div className="p-6 cursor-pointer hover:bg-gray-50 transition-colors">
                    <div className="flex flex-col md:flex-row justify-between items-start md:items-center">
                        <div className="mb-4 md:mb-0">
                            <div className="flex items-center space-x-4">
                                <span className="text-sm font-medium text-gray-900"><DateTimeSpan date={date}/></span>
                                <span className="px-3 py-1 rounded-full text-xs font-medium">
                                    Stato ordine: <OrderStatusSpan status={status}/></span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default OrderStatusCard;